import React from 'react'
import {FormattedMessage} from 'react-intl'

import CheckboxCheckedImage from 'assets/icons/checkbox-checked'
import CheckboxUnCheckedImage from 'assets/icons/checkbox-unchecked'

import { Error, CheckedIcon, CheckBoxWrapper, CheckBoxContainer } from './style'

export default function Checkbox({
  label,
  checked,
  onChange,
  dataTest,
  error,
  field,
  disabled
}) {
  return (
    <>
      <CheckBoxContainer
        aria-label={label}
        data-testid={dataTest || 'test-checkbox'}
        disabled={disabled}
        onClick={!disabled ? onChange : undefined}
      >
        <CheckBoxWrapper data-testid='test-checkbox-wrapper' disabled={disabled} onClick={!disabled ? onChange : undefined} data-test={dataTest}>
          {checked ? <CheckedIcon data-testid='test-checked-icon' disabled={disabled}><CheckboxCheckedImage /></CheckedIcon> : <CheckboxUnCheckedImage />}
        </CheckBoxWrapper>
        <label>{label}</label>
      </CheckBoxContainer>
      {error && error.field === field && (
        <Error data-test="validation-error-message" data-testid="test-error">
          <FormattedMessage id={error.error} />
        </Error>
      )}
    </>
  )
}

import PropTypes from 'prop-types';

Checkbox.propTypes = {
  label: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  dataTest: PropTypes.string,
  error: PropTypes.shape({
    field: PropTypes.string,
    error: PropTypes.string
  }),
  field: PropTypes.string,
  disabled: PropTypes.bool
};
